import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SignOutLink } from './links/SignOutLink';
import { GenericLink } from './links/GenericLink';
import { MyHomeLink } from './links/MyHomeLink';
import { InboxLink } from './links/InboxLink';
import { useAuth, UseAuthReturn } from 'src/pages/SignIn/hooks/useAuth';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import './Navigation.scss';

const Navigation = ({ links, collapseSideBar }) => {
  const [isSignOutModalOpen, setIsSignOutModalOpen] = useState(false);

  const userSuiteList = useSelector(
    (state: any) => state?.userSuites?.userSuiteList || []
  );

  const { loading, signOut }: UseAuthReturn = useAuth();

  let displayLinks: any = links;

  if (!userSuiteList || userSuiteList.length === 0) {
    displayLinks = links.filter((link: any) => link.label !== 'My Home');
  }

  const handleConfirmSignOut = () => {
    signOut();
    setIsSignOutModalOpen(false);
  };

  const handleCancelSignOut = () => {
    setIsSignOutModalOpen(false);
  };

  return (
    <nav className="navigation">
      <ul className="navigation__links">
        {displayLinks.map((link: any, i: any) => {
          switch (link.label) {
            case 'Sign Out':
              return (
                <SignOutLink
                  key={i}
                  link={link}
                  loading={loading}
                  collapseSideBar={collapseSideBar}
                  onClick={() => setIsSignOutModalOpen(true)} // Open modal on click
                />
              );
            case 'My Home':
              return (
                <MyHomeLink
                  key={i}
                  link={link}
                  collapseSideBar={collapseSideBar}
                />
              );
            case 'Inbox':
              return (
                <InboxLink
                  key={i}
                  link={link}
                  collapseSideBar={collapseSideBar}
                />
              );
            default:
              return (
                <GenericLink
                  key={i}
                  link={link}
                  collapseSideBar={collapseSideBar}
                />
              );
          }
        })}
      </ul>
      {isSignOutModalOpen && (
        <ConfirmationModal
          title="Sign Out"
          message="Are you sure you want to sign out?"
          confirmLabel="Sign Out"
          cancelLabel="Cancel"
          variant="confirmation"
          isSubmitting={loading}
          onConfirm={handleConfirmSignOut}
          onCancel={handleCancelSignOut}
        />
      )}
    </nav>
  );
};

export default Navigation;
